"use strict";

(() => {
	class Portfolios {
		/** @var {HTMLElement} */
		#$widget;

		/** @var {HTMLInputElement} */
		#$investmentInput;

		/** @var {NodeList<HTMLElement>} */
		#$portfolios;


		constructor($widget) {
			this.#$widget = $widget;
		}

		initialize() {
			// Initialize inputs.
			this.#$investmentInput = this.#$widget.querySelector(".dan-input-investment");
			this.#$investmentInput.addEventListener("input", (this.refreshPortfolios).bind(this));

			// Initialize portfolios.
			this.#$portfolios = this.#$widget.querySelectorAll(".dan-portfolio");

			for (const $portfolio of this.#$portfolios) {
				this.#initializePortfolio($portfolio);
			}

			this.refreshPortfolios();

			// Initialize tooltips.
			const $tooltips = this.#$widget.querySelectorAll("[data-tooltip]");

			if ($tooltips.length > 0) {
				// noinspection JSUnresolvedReference
				tippy($tooltips, {
					content: ($element) => $element.getAttribute("data-tooltip"),
					allowHTML: true
				});
			}
		}

		#initializePortfolio($portfolio) {
			const $chart     = $portfolio.querySelector(".dan-portfolio-chart");
			const $allowRows = $portfolio.querySelectorAll(".dan-portfolio-allocations tr[data-name][data-allocation]");

			// Build allocations.
			const allocations = [];

			for (const $row of $allowRows) {
				const allocName    = $row.getAttribute("data-name");
				const allocPercent = parseInt($row.getAttribute("data-allocation"));
				const allocColor   = $row.getAttribute("data-color") || "#292929";

				if (allocName && !isNaN(allocPercent)) {
					allocations.push({
						name: allocName,
						percent: allocPercent,
						color: allocColor
					});
				}
			}

			// Initialize chart.
			$portfolio.chart = new Chart($chart, {
				type: "doughnut",
				data: {
					labels: allocations.map((row) => row.name),
					datasets: [{
						label: "Alokace",
						data: allocations.map((row) => row.percent),
						backgroundColor: allocations.map((row) => row.color)
					}]
				},
				options: {
					aspectRatio: 1,
					plugins: {
						legend: {
							position: "bottom",
							onClick: null,
							labels: {
								boxWidth: 12,
								boxHeight: 12
							}
						},
						tooltip: {
							displayColors: false,
							callbacks: {
								label: (context) => {
									const inputs = this.getInputs();
									let label    = Dan_Utilities.formatNumber(context.raw, 0, ",", " ") + " %";

									if (inputs.investment) {
										const amount = (inputs.investment / 100 * context.raw);
										label += " / " + Dan_Utilities.formatPrice(amount) + " Kč";
									}

									return label;
								}
							}
						}
					}
				},
			});
		}

		refreshPortfolios() {
			const inputs = this.getInputs();

			for (const $portfolio of this.#$portfolios) {
				this.#refreshPortfolio($portfolio, inputs);
			}
		}

		#refreshPortfolio($portfolio, inputs) {
			const $allowRows = $portfolio.querySelectorAll(".dan-portfolio-allocations tr[data-name][data-allocation]");

			for (const $row of $allowRows) {
				const $amountCol = $row.querySelector(".dan-portfolio-amount");

				if (!$amountCol) {
					continue;
				}

				const allocPercent = parseInt($row.getAttribute("data-allocation"));

				if (inputs.investment && !isNaN(allocPercent)) {
					const amount = (inputs.investment / 100 * allocPercent);
					$amountCol.textContent = Dan_Utilities.formatPrice(amount) + " Kč";
				} else {
					$amountCol.textContent = "-";
				}
			}
		}

		getInputs() {
			// Investment.
			let investment;
			investment = this.#$investmentInput.value || this.#$investmentInput.placeholder;
			investment = parseInt(investment);

			if (isNaN(investment) || investment <= 0) {
				investment = null;
			}

			// Return.
			return {
				investment: investment
			};
		}
	}

	// Initialize widgets.
	const $widgets = document.querySelectorAll(".dan-portfolios");

	for (const $widget of $widgets) {
		$widget.calculator = new Portfolios($widget);
		$widget.calculator.initialize();
	}
})();
